import React from 'react'
import injectSheet from 'react-jss'
import { Modal } from '../../'
import Info from '../../icons/infoIcon'

class InfoButton extends React.Component {
  constructor() {
    super()

    this.state = {
      open: false,
    }

    this.openModal = this.openModal.bind(this)
    this.closeModal = this.closeModal.bind(this)
  }

  openModal() {
    this.setState({
      open: true,
    })
  }

  closeModal() {
    this.setState({
      open: false,
    })
  }

  render() {
    const {
      classes,
      modalText,
      modalTitle,
      primary,
      tip,
    } = this.props

    const { open } = this.state

    return (
      <div className={`${classes.iconButtonContainer}`}>
        <div
          className={`${classes.iconButton} ${primary && 'primary'}`}
          role="button"
          tabIndex={0}
          onClick={this.openModal}
          onKeyDown={() => false}
        >
          <Info />
          {tip && (
            <div className={`${classes.tip}`}>{tip}</div>
          )}
        </div>
        {open && (
          <Modal
            closeModal={this.closeModal}
            closeModalText="schliessen"
            info
            text={modalText}
            title={modalTitle}
          />
        )}
      </div>
    )
  }
}

const styles = theme => ({
  iconButtonContainer: {
    opacity: 1,
    cursor: 'pointer',
    width: '12px',
    height: '12px',
    minWidth: '12px',
    transition: [
      {
        property: 'opacity',
        duration: theme.speed.fast,
      },
    ],
  },
  iconButton: {
    position: 'relative',
    display: 'flex',
    height: '100%',
    backgroundColor: theme.colors.secondary_3b,
    borderColor: theme.colors.secondary_3b,
    borderWidth: '2px',
    borderStyle: 'solid',
    borderRadius: '50%',
    transition: [
      {
        property: 'color',
        duration: theme.speed.fast,
      },
      {
        property: 'background-color',
        duration: theme.speed.fast,
      },
    ],
    '& svg': {
      padding: '10%',
      fill: theme.colors.main_2,
    },
    '& $tip': {
      color: theme.colors.secondary_3b,
    },
    '&:hover': {
      backgroundColor: theme.colors.main_2,
      '& svg': {
        fill: theme.colors.secondary_3b,
        transition: [
          {
            property: 'fill',
            duration: theme.speed.fast,
          },
        ],
      },
      '& $tip': {
        zIndex: 1,
        opacity: 1,
        transition: [
          {
            property: 'opacity',
            duration: theme.speed.medium,
            delay: theme.speed.fast,
          },
        ],
      },
    },
    '&.primary': {
      borderColor: theme.colors.main_1,
      backgroundColor: theme.colors.main_1,
      '& svg': {
        fill: theme.colors.main_2,
      },
      '& $tip': {
        color: theme.colors.secondary_3b,
      },
      '&:hover': {
        backgroundColor: theme.colors.main_2,
        '& svg': {
          fill: theme.colors.main_1,
        },
      },
    },
    '& > *': {
      width: '100%',
      height: '100%',
    },
  },
  tip: {
    position: 'absolute',
    padding: `2px ${theme.sizes.gutter / 2}px`,
    top: '-5px',
    left: '50%',
    transform: 'translate(-50%, -100%)',
    width: 'auto',
    whiteSpace: 'nowrap',
    fontSize: '0.5em',
    height: 'calc(0.5rem + 4px)',
    borderRadius: 'calc(0.25rem + 2px)',
    backgroundColor: theme.colors.secondary_3a,
    zIndex: -1,
    opacity: 0,
    transition: [
      {
        property: 'opacity',
        duration: theme.speed.fast,
        delay: 0,
      },
    ],
  },
})

export default injectSheet(styles)(InfoButton)



// WEBPACK FOOTER //
// ./src/modules/core/components/infoButton.jsx